import BaseType from "@/types/BaseType";

export default class CanvasSyncSettings extends BaseType {
  // How far back (in hours) each refresh pulls Canvas completions. Default 25 = 24h + 1h overlap.
  LookbackHours: number = 25;
}
